var android = undefined;
var doc_type = "";
export default class JsInterfaceService {

    static enterFullScreen() {
        // console.log("enterFullScreen");
        const ua = navigator.userAgent.toLowerCase();
        const isAndroid = ua.indexOf("android") > -1;
        try {
            if (isAndroid) {
                android = LoanWeb;
                if (typeof android !== "undefined") android.enterFullScreen("");
            } else {
                window.webkit.messageHandlers.enterFullScreen.postMessage("");
            }
        } catch (error) {
            console.error(error);
            // console.log("error enterFullScreen");
            throw error;
        }
    }
    static exitEntryPoint() {
        // console.log("exitEntryPoint");
        const ua = navigator.userAgent.toLowerCase();
        const isAndroid = ua.indexOf("android") > -1;
        try {
            if (isAndroid) {
                android = LoanWeb;
                if (typeof android !== "undefined") android.exitEntryPoint("");
            } else {
                window.webkit.messageHandlers.exitEntryPoint.postMessage("");
            }
        } catch (error) {
            console.error(error);
            // console.log("error exitEntryPoint");
            throw error;
        }
    }
    static requestCamera() {
        // console.log("requestCamera");
        const ua = navigator.userAgent.toLowerCase();
        const isAndroid = ua.indexOf("android") > -1;

        try {
            if (isAndroid) {
                android = LoanWeb;
                if (typeof android !== "undefined") android.requestCamera("");
            } else {
                window.webkit.messageHandlers.requestCamera.postMessage("");
            }
        } catch (error) {
            console.error(error);
            // console.log("error requestCamera");
            throw error;
        }
    }
    static openCamera() {
        // console.log("openCamera");
        try {
            if (doc_type == "") {
                document.getElementById("fileBrowseImage").click();
            } else {
                document.getElementById("fileBrowseImage_" + doc_type).click();
            }
        } catch (error) {
            console.error(error);
            // console.log("error openCamera");
            throw error;
        }
    }
    static setDocType(docId) {
        // console.log("setDocType", docId);
        doc_type = docId;
        return doc_type;
    }

    static gaTagging(
        event,
        customDimensions
    ) {
      
        const data =
            customDimensions.length > 0
                ? { event, customDimensions }
                : { event };

        console.log('========== START GA TAGGING ==========');
        const body = JSON.stringify(data);
        const ua = navigator.userAgent.toLowerCase();
        const isAndroid = ua.indexOf('android') > -1;

        console.log('Platform =>', isAndroid ? 'Android' : 'iOS');
        console.log('Tagging At', new Date().toString());
        console.log('Payload =>', data);
        try {
            if (isAndroid) {
                android = LoanWeb;
                if (typeof android !== "undefined"){
                    android.gaTagging?.(body);
                }else{
                    window.JSBridge.gaTagging?.(body);
                } 
            
            } else {
                window.webkit.messageHandlers.gaTagging.postMessage(body);
            }
            console.log('Status => Success');
        } catch (error) {
            console.log('Status => Fail');
            console.log(`Error => ${error}`);
        } finally {
            console.log('=========== END GA TAGGING ===========');
        }
    }
    static openInternalDeepLink(deeplinkUrl) {

        console.log("openInternalDeepLink");
        const ua = navigator.userAgent.toLowerCase();
        const isAndroid = ua.indexOf("android") > -1;

        try {
            if (isAndroid) {
                android = LoanWeb;
                if (typeof android !== "undefined") android.openInternalDeepLink?.(true, deeplinkUrl);
            } else if (window.JSBridge) {
                window.JSBridge.openInternalDeepLink?.(true, deeplinkUrl)
            } else {
                const data = {
                    closeCurrentWebview: true,
                    deepLink: deeplinkUrl
                }
                window.webkit.messageHandlers.openInternalDeepLink.postMessage(JSON.stringify(data));
            }
        } catch (error) {
            console.error("openInternalDeepLink", error);
        }
    }
}
